import React, { useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { motion, useMotionValueEvent, useScroll, useTransform } from 'framer-motion';

const VideoShort = ({ src, title, isMuted = false, containerRef, videoRef, loop, showControls, css, className, ...props }) => {

  // const videoRef = useRef(null);
  const internalVideoRef = useRef(null);
  const ref = videoRef || internalVideoRef;

  const [mute/* , setMute */] = useState(true);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });

  const video = { entry: .5, exit: .70 };

  const volume = useTransform(scrollYProgress, [0.2, video.entry, video.exit, 1], [0, 1, 1, 0]);

  /* useMotionValueEvent(scrollYProgress, "change", (latest) => {
    console.log(title, " scroll", latest)
  }); */

  /*   useLayoutEffect(() => {
      if (ref.current) {
        ref.current.play();
      }
    }, []); */

  // Update the video element's volume
  useMotionValueEvent(volume, 'change', (v) => {
    if (ref.current) {
      ref.current.volume = v; // Set volume dynamically
      ref.current.muted = v === 0; // Mute when volume is 0
    } /* else if (scrollYProgress >= .95) {
      ref.current.stop()
    } */
  });



  return (
    <motion.video
      id={title}
      key={title}
      ref={ref}
      autoPlay={true} muted={mute} loop={loop || true}
      playsInline
      // style={{ opacity }}
      className={twMerge("object-cover full relative", css, className)}
      controls={showControls}
      controlsList="nodownload"
      onContextMenu={(e) => e.preventDefault()}
    >
      <source src={src} className={`full`} />
    </motion.video>
  )
}

export default VideoShort;